import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { authGuard } from './auth/auth.guard';
import { MainLayoutComponent } from './main-layout/main-layout.component';

export const appRoutes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'customers' },
      { path: 'dashboard', pathMatch: 'full', redirectTo: 'customers' },
      {
        path: 'customers',
        loadComponent: () =>
          import('./customers/customers-list.component').then((m) => m.CustomersListComponent),
      },
      {
        path: 'cruds',
        loadComponent: () =>
          import('./crud-builder/crud-list.component').then((m) => m.CrudListComponent),
      },
      {
        path: 'cruds/new',
        loadComponent: () =>
          import('./crud-builder/crud-builder.component').then((m) => m.CrudBuilderComponent),
      },
      {
        path: 'cruds/edit/:crudId',
        loadComponent: () =>
          import('./crud-builder/crud-builder.component').then((m) => m.CrudBuilderComponent),
      },
      {
        path: 'run/:crudId',
        loadComponent: () =>
          import('./run-crud/run-crud-view.component').then((m) => m.RunCrudViewComponent),
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
